import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import LandingPage from './components/LandingPage';
import WebsitesPage from './components/WebsitesPage';
import EmailDashboard from './components/EmailDashboard';
import { TermsOfService } from './components/TermsOfService';
import { PrivacyPolicy } from './components/PrivacyPolicy';

function App() {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Check URL path to determine which page to show
    const path = window.location.pathname;
    if (path === '/websites') {
      setCurrentPage('websites');
    } else if (path === '/emails') {
      setCurrentPage('emails');
    } else if (path === '/terms') {
      setCurrentPage('terms');
    } else if (path === '/privacy') {
      setCurrentPage('privacy');
    } else {
      setCurrentPage('home');
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Handle browser navigation
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/websites') {
        setCurrentPage('websites');
      } else if (path === '/emails') {
        setCurrentPage('emails');
      } else if (path === '/terms') {
        setCurrentPage('terms');
      } else if (path === '/privacy') {
        setCurrentPage('privacy');
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-purple-900 flex items-center justify-center">
        <Zap size={64} className="text-yellow-400 animate-pulse" />
      </div>
    );
  }

  if (currentPage === 'websites') {
    return <WebsitesPage />;
  }

  if (currentPage === 'emails') {
    return <EmailDashboard />;
  }

  if (currentPage === 'terms') {
    return <TermsOfService />;
  }

  if (currentPage === 'privacy') {
    return <PrivacyPolicy />;
  }

  return <LandingPage />;
}

export default App;